import { FulfillmentGroupActions } from "./outbound-label-enums";

export const HidePriceActionButtons: FulfillmentGroupActions[] = [
  FulfillmentGroupActions.MARK_AS_FULFILLED,
  FulfillmentGroupActions.READY_FOR_PICKUP,
  FulfillmentGroupActions.MARK_AS_PICKED_UP,
];

export const DefaultActionButtonCandidates = [
  FulfillmentGroupActions.CREATE_AND_PRINT_LABEL,
  FulfillmentGroupActions.PRINT_PACKING_SLIP,
  FulfillmentGroupActions.PRINT_PICK_LIST,
  FulfillmentGroupActions.PRINT_ORDER_SUMMARY,
  FulfillmentGroupActions.EXPORT_PICK_LIST_CSV,
];
